// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-root-aET {\n    font-size: 0;\n    height: auto;\n}\n\n.video-inner-voZ {\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n}\n\n.video-wrapper-kbT {\n    overflow: hidden;\n    transform: translateZ(0px);\n    height: 100%;\n}\n\n.video-container-HAK {\n    overflow: hidden;\n    padding-top: 56.25%;\n    position: relative;\n    height: 100%;\n}\n\n.video-video--kJ {\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n}\n\n.video-video--kJ .video-player-MfV .video-vp-controls-Gis .video-play-NVO {\n    display: none !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "video-root-aET",
	"inner": "video-inner-voZ",
	"wrapper": "video-wrapper-kbT",
	"container": "video-container-HAK",
	"video": "video-video--kJ",
	"player": "video-player-MfV",
	"vp-controls": "video-vp-controls-Gis",
	"play": "video-play-NVO"
};
export default ___CSS_LOADER_EXPORT___;
